var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse, _ellipse2, _path40, _path41, _path42, _path43, _path44, _path45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 54 58",
    width: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.1333 27.2481-3.6834 2.1266c-.1672-.2892-.3437-.5724-.529-.8493l3.7124-2.1433z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.1333 27.2481-3.6834 2.1266c-.1672-.2892-.3437-.5724-.529-.8493l3.7124-2.1433z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.1333 27.2481-3.6834 2.1266c-.1672-.2892-.3437-.5724-.529-.8493l3.7124-2.1433z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.1333 27.2481-3.6834 2.1266c-.1672-.2892-.3437-.5724-.529-.8493l3.7124-2.1433z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.1333 27.2481-3.6834 2.1266c-.1672-.2892-.3437-.5724-.529-.8493l3.7124-2.1433z",
    fill: "#ba43ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.4915 36.9415h6.9281v-1h-6.9645c.0228.3306.035.664.0364 1z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.4915 36.9415h6.9281v-1h-6.9645c.0228.3306.035.664.0364 1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m42.4915 36.9415h6.9281v-1h-6.9645c.0228.3306.035.664.0364 1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m42.4915 36.9415h6.9281v-1h-6.9645c.0228.3306.035.664.0364 1z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m42.4915 36.9415h6.9281v-1h-6.9645c.0228.3306.035.664.0364 1z",
    fill: "#ba43ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6332 46.5009-3.1934-1.8438c.167-.288.325-.5819.4733-.8814l3.2201 1.8591z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6332 46.5009-3.1934-1.8438c.167-.288.325-.5819.4733-.8814l3.2201 1.8591z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6332 46.5009-3.1934-1.8438c.167-.288.325-.5819.4733-.8814l3.2201 1.8591z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6332 46.5009-3.1934-1.8438c.167-.288.325-.5819.4733-.8814l3.2201 1.8591z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6332 46.5009-3.1934-1.8438c.167-.288.325-.5819.4733-.8814l3.2201 1.8591z",
    fill: "#ba43ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m18.9111 49.8153c.2791.1815.5646.3541.8559.5175l-3.229 5.5929-.8661-.5z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m18.9111 49.8153c.2791.1815.5646.3541.8559.5175l-3.229 5.5929-.8661-.5z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m18.9111 49.8153c.2791.1815.5646.3541.8559.5175l-3.229 5.5929-.8661-.5z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m18.9111 49.8153c.2791.1815.5646.3541.8559.5175l-3.229 5.5929-.8661-.5z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m18.9111 49.8153c.2791.1815.5646.3541.8559.5175l-3.229 5.5929-.8661-.5z",
    fill: "#ba43ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2241 52.2747c.1625 0 .3245-.0025.4857-.0076v3.9599h-1v-3.9608c.1708.0057.3422.0085.5143.0085z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2241 52.2747c.1625 0 .3245-.0025.4857-.0076v3.9599h-1v-3.9608c.1708.0057.3422.0085.5143.0085z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2241 52.2747c.1625 0 .3245-.0025.4857-.0076v3.9599h-1v-3.9608c.1708.0057.3422.0085.5143.0085z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2241 52.2747c.1625 0 .3245-.0025.4857-.0076v3.9599h-1v-3.9608c.1708.0057.3422.0085.5143.0085z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2241 52.2747c.1625 0 .3245-.0025.4857-.0076v3.9599h-1v-3.9608c.1708.0057.3422.0085.5143.0085z",
    fill: "#ba43ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6596 50.3449c.2916-.1629.5773-.3351.8567-.5162l3.2315 5.597-.8661.5z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6596 50.3449c.2916-.1629.5773-.3351.8567-.5162l3.2315 5.597-.8661.5z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6596 50.3449c.2916-.1629.5773-.3351.8567-.5162l3.2315 5.597-.8661.5z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6596 50.3449c.2916-.1629.5773-.3351.8567-.5162l3.2315 5.597-.8661.5z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m34.6596 50.3449c.2916-.1629.5773-.3351.8567-.5162l3.2315 5.597-.8661.5z",
    fill: "#ba43ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m10.7865 26.3821 3.7329 2.1552c-.185.277-.3612.5603-.5282.8497l-3.7047-2.1389z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m10.7865 26.3821 3.7329 2.1552c-.185.277-.3612.5603-.5282.8497l-3.7047-2.1389z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m10.7865 26.3821 3.7329 2.1552c-.185.277-.3612.5603-.5282.8497l-3.7047-2.1389z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m10.7865 26.3821 3.7329 2.1552c-.185.277-.3612.5603-.5282.8497l-3.7047-2.1389z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m10.7865 26.3821 3.7329 2.1552c-.185.277-.3612.5603-.5282.8497l-3.7047-2.1389z",
    fill: "#ba43ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9932 35.9415h-6.9932v1h6.9567c.0014-.336.0137-.6694.0365-1z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9932 35.9415h-6.9932v1h6.9567c.0014-.336.0137-.6694.0365-1z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9932 35.9415h-6.9932v1h6.9567c.0014-.336.0137-.6694.0365-1z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9932 35.9415h-6.9932v1h6.9567c.0014-.336.0137-.6694.0365-1z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m11.9932 35.9415h-6.9932v1h6.9567c.0014-.336.0137-.6694.0365-1z",
    fill: "#ba43ff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2866 45.6348 3.2422-1.8719c.1481.2997.3057.5938.4725.8819l-3.2147 1.8561z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2866 45.6348 3.2422-1.8719c.1481.2997.3057.5938.4725.8819l-3.2147 1.8561z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2866 45.6348 3.2422-1.8719c.1481.2997.3057.5938.4725.8819l-3.2147 1.8561z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2866 45.6348 3.2422-1.8719c.1481.2997.3057.5938.4725.8819l-3.2147 1.8561z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2866 45.6348 3.2422-1.8719c.1481.2997.3057.5938.4725.8819l-3.2147 1.8561z",
    fill: "#ba43ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1989,
    cy: 36.5413,
    rx: 12.5,
    ry: 12.4586,
    stroke: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1989,
    cy: 36.5413,
    rx: 12.5,
    ry: 12.4586,
    stroke: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m26.7191 30.477c.3673-.7417 1.4251-.7417 1.7923 0l1.1632 2.349c.1459.2947.4273.4988.7528.5459l2.5954.3759c.8212.1189 1.1486 1.1287.5535 1.7069l-1.8738 1.8205c-.2367.2299-.3447.5617-.2887.8868l.4429 2.5739c.1405.8164-.7158 1.4399-1.4497 1.0553l-2.3276-1.2196c-.2907-.1523-.6376-.1523-.9283 0l-2.3276 1.2196c-.7338.3846-1.5902-.2389-1.4497-1.0553l.443-2.5739c.0559-.3251-.0521-.6569-.2887-.8868l-1.8738-1.8205c-.5952-.5782-.2678-1.588.5535-1.7069l2.5953-.3759c.3255-.0471.6069-.2512.7529-.5459z",
    stroke: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m33.2155 1.15967v20.73423",
    stroke: "#ba43ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m21.6064 1.17163c-3.4075-.00004-5.9075.32837-5.9075 2.82813v22.00004c2.194-2.0546 3.5045-2.9684 5.9075-4z",
    fill: "#ba43ff",
    opacity: 0.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m32.6989 1c3.4075-.000037 5.9075.32837 5.9075 2.82813v22.00007c-2.194-2.0546-3.5045-2.9685-5.9075-4z",
    fill: "#ba43ff",
    opacity: 0.4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5708 1.15967v20.73423",
    stroke: "#ba43ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m18.7207 1.15967h16.9783c1.6568 0 3 1.34314 3 3v21.94793c-2.8364-3.1367-6.9381-5.1076-11.5001-5.1076-4.5503 0-8.6426 1.9607-11.4782 5.0834v-21.92373c0-1.65686 1.3431-3 3-3z",
    stroke: "#ba43ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperience);
export default __webpack_public_path__ + "static/media/Icon-Experience.c2e177165b3c52acdfe39a26e4ace4aa.svg";
export { ForwardRef as ReactComponent };